import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { formatExpense, formatValue } from "../shared/FinancialViewHelpers";
import Input from "../../../shared/Input";

const CollaboratorExpense = ({
  value,
  listingData,
  setFinancialData,
  expense,
  recalculateCollaboratorExpenses,
}) => (
  <div className="collaborator-content">
    <Row>
      <Col xs={2}>
        <label>{value.name}</label>
        <Input
          value={value.value}
          onChange={(e) => {
            // eslint-disable-next-line no-param-reassign
            value.value = e.target.value;
            setFinancialData(listingData);
            recalculateCollaboratorExpenses(expense, listingData);
          }}
        />
      </Col>
      <Col xs={4}>
        <div className="form-group">
          <label>
            Notes
            <textarea
              className="description form-control"
              placeholder=""
              value={value.notes || ""}
              onChange={(e) => {
                // eslint-disable-next-line no-param-reassign
                value.notes = e.target.value;
                setFinancialData(listingData);
              }}
            />
          </label>
        </div>
      </Col>
      <Col xs={1} />
      <Col xs={2} className="text-right">
        <span>{formatExpense(formatValue(value.expense_amount, false))}</span>
      </Col>
      <Col xs={2} className="text-right">
        <span>{formatValue(value.line_total)}</span>
      </Col>
    </Row>
  </div>
);

CollaboratorExpense.propTypes = {
  value: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    notes: PropTypes.string,
    expense_amount: PropTypes.number,
    line_total: PropTypes.number,
  }).isRequired,
  listingData: PropTypes.shape().isRequired,
  setFinancialData: PropTypes.func.isRequired,
  expense: PropTypes.shape().isRequired,
  recalculateCollaboratorExpenses: PropTypes.func.isRequired,
};

export default CollaboratorExpense;
